<div class="modal-content d-flex flex-column">
  <div class="section-title apm-text-red text-break">
    {{ 448884 | apmTranslate }}
  </div>
  <hr class="gray-divider-1 mb-4" />
  <div class="position-relative">
    @if (canViewMarkup) {
      <mat-tab-group [(selectedIndex)]="selectedIndex">
        <mat-tab label="{{ '444725' | apmTranslate }}">
          <ng-container *ngTemplateOutlet="priceListTable"></ng-container>
        </mat-tab>
        <mat-tab label="{{ '444793' | apmTranslate }}">
          <ng-container *ngTemplateOutlet="markupTable"></ng-container>
        </mat-tab>
        <mat-tab label="{{ '445580' | apmTranslate }}">
          <ng-container *ngTemplateOutlet="extendedWarrantiesTable"></ng-container>
        </mat-tab>
      </mat-tab-group>
    } @else {
      <ng-container *ngTemplateOutlet="priceListTable"></ng-container>
    }
  </div>

  <div class="d-flex flex-row justify-content-end mt-3">
    <apm-button class="me-2" variant="secondary" (click)="closeDialog()" additionalClass="px-5">{{
      '444686' | apmTranslate
    }}</apm-button>
  </div>
</div>

<ng-template #priceListTable>
  <div class="table-div">
    <apm-server-side-table
      [columnDefs]="priceListColumnDefs()"
      [dataSource]="priceListDataSource"
      [cacheBlockSize]="cacheBlockSize"
    />
  </div>
</ng-template>

<ng-template #markupTable>
  @defer (when selectedIndex() === 1) {
    <div class="table-div">
      <apm-server-side-table
        [columnDefs]="markupColumnDefs()"
        [dataSource]="markupDataSource"
        [cacheBlockSize]="cacheBlockSize"
      />
    </div>
  }
</ng-template>

<ng-template #extendedWarrantiesTable>
  @defer (when selectedIndex() === 2) {
    <div class="table-div">
      <apm-server-side-table
        [columnDefs]="extendedWarrantiesColumnDefs()"
        [dataSource]="extendedWarrantiesDataSource"
        [cacheBlockSize]="cacheBlockSize"
      />
    </div>
  }
</ng-template>
